import React, { useState, useEffect, useCallback, useRef } from 'react';
import './app.less';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import {
  isInApp,
  requestLocation
} from '../../utils/common';
import Toast from '@xpeng/rc-toast';
import {
  StationDto,
  StationStatusEnum,
} from '../../api/stations';
import TypeTag from './type-tag';
import { throttle, flatten } from '../../utils/common';
import { queryStationDtl, queryMapLabeling, queryMapCityLabeling, queryMapAggregateLabeling, findNearByStationV2 } from "../../api/map-stations"
import type { StationPoint, StationComponent, NearByStationVO } from "../../api/map-stations"
import { location2CityCode } from "../map-stations/config"

declare const AMap: any;

const defalutPoint = {
  lng: 113.38477,
  lat: 23.15944,
  citycode: '020',
  cityName: '广州市'
}
interface Location {
  lng: number;
  lat: number;
}
interface StationShow extends StationDto {
  price?: number;
}
// 地图marker收集
const MarkerCollector = new Map<string, any>();
const StationCache = new Map<string, StationShow>();

/**
 * [通过参数名获取url中的参数值]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
 * @param  {[string]} queryName [参数名]
 * @return {[string]}           [参数值]
 */
const getUrlValue = queryName => {
  let reg = new RegExp('(^|&)' + queryName + '=([^&]*)(&|$)', 'i');
  const query = window.location.search; // '?s=1&f=7'
  let r = query.substr(1).match(reg);
  if (r != null) {
    return decodeURI(r[2]);
  } else {
    return null;
  }
};

// 获取高德定位promise
const getLocationGeoPro = _map => {
  return new Promise((resolve, reject) => {
    _map.plugin('AMap.Geolocation', () => {
      const geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, // 是否使用高精度定位，默认:true
        timeout: 10000, // 超过10秒后停止定位，默认：无穷大
        buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        buttonPosition: 'RB'
      });
      geolocation.getCurrentPosition((status, result) => {
        if (status === 'complete') {
          // console.log(result);
          const address = result && result.addressComponent;
          const cityName = (address && address.city) || (address && address.province);
          // resolve({ lng: result.position.lng, lat: result.position.lat });
          console.log('address', address);
          resolve({
            lng: result.position.lng,
            lat: result.position.lat,
            citycode: address.citycode,
            cityName
          });
        } else {
          console.error('高德定位失败:' + result.message);
          resolve(defalutPoint);
        }
      });
    });
  });
};
// 获取App定位promise
const getAppPositionPro = () => {
  return new Promise((resolve, reject) => {
    if (isInApp()) {
      requestLocation().then(res => {
        if (res.code === 0) {
          resolve({
            lng: res.data.coords.longitude,
            lat: res.data.coords.latitude
          });
        } else {
          console.error('App定位失败', res);
          reject();
        }
      });
    } else {
      reject(-1);
    }
  });
};
const MyLocationPoint = `<div class="my-location"></div>`;
const App = () => {
  const MyLocaleRef = useRef<Location | null>(null);
  const CountryMarkerCollector = new Map<string, any>();
  const CenterLocaleRef = useRef<Location | null>(null);
  const ClusterRef = useRef<any>(null);
  const CountryClusterRef = useRef<any>(null);
  const CurrentStationIdRef = useRef<string>('');
  const [$map, set$map] = useState<any>(null);
  const [freshLoading, setFreshLoading] = useState<boolean>(false);
  const [rulesFlag, setRulesFlag] = useState<boolean>(true);

  const [currentStation, setCurrentStation] = useState<StationShow | null>(
    null
  );

  // 请求城市全部
  const queryCitysServiceInstance = React.useRef<ReturnType<typeof queryMapCityLabeling>>(queryMapCityLabeling());
  // 请求附近20km站点
  const queryLabelingServiceInstance = React.useRef<ReturnType<typeof queryMapLabeling>>(queryMapLabeling());
  // 保存需要取消的请求实例
  const cancelList = useRef<any[]>([])

  const map2 = useRef<any>(null)

  // 中心坐标
  const locationMarker = new Map<string, any>();
  const wholeCityNums = useRef<any[]>(null) as any
  // 保存需要取消的请求实例
  const queryMapAggregateLabelingServiceInstance = React.useRef<ReturnType<typeof queryMapAggregateLabeling>>(queryMapAggregateLabeling());


  const dupRemove = (list: any[], key: string) => {
    let map = new Map()
    return list.filter(i => {
      return !map.has(i[key].toString()) && map.set(i[key].toString(), '')
    })
  }

  const queryLabelingThrottler = React.useRef(
    throttle(async ({ map, lat, lng, citycode }) => {
      try {
        setFreshLoading(true)
        let res1 = await queryLabelingServiceInstance.current.axiosFun({
          source: 2,
          latitude: lat,
          longitude: lng,
          filterCriteriaCodeList: ["freeCharging"]
        }, cancelList.current)
        let res2 = await queryCitysServiceInstance.current.axiosFun({
          source: 2,
          cityCode: citycode,
          filterCriteriaCodeList: ["freeCharging"]
        }, cancelList.current)
        let data1 = res1.data?.result || []
        let data2 = res2.data?.result || []
        let stationList = dupRemove([...data1, ...data2], 'stationId')
        setFreshLoading(false);
        console.log('stationList', stationList);

        drawStation(stationList, map);
        // @ts-ignore
      } catch (error: any) {
        setFreshLoading(false);
        console.log('queryLabelingThrottler error', error);
        if (error?.message === 'cancel') {
          return
        }
      }
    }, 500)
  );
  const getStationInfo = (stationId, stationCache) => {
    console.log(stationCache, 'stationCache')
    if (StationCache.has(stationId)) {
      setCurrentStation(StationCache.get(stationId) as StationShow);
      return;
    }
    // 获取具体的免费站信息
    queryStationDtl({ stationId: stationId })
      .then(res => {
        let { data } = res;
        if (data) {
          setCurrentStation({ ...stationCache, ...data });
        }
      })
      .catch(err => {
        Toast.show(err.message);
      })


  };

  useEffect(() => {
    const map = new AMap.Map('amap-wrap', {
      zoom: 5,
      zooms: [5, 20],
      resizeEnable: true,
      animateEnable: true,
      expandZoomRange: true // zooms设置20无效，是否支持可以扩展最大缩放级别,和zooms属性配合使用，设置为true的时候，zooms的最大级别在PC上可以扩大到20级，移动端还是高清19/非高清20
    });
    set$map(map);
    map2.current = map
    map.on('moveend', mapMoveFunc);
  }, []);

  const mapMoveFunc = async (e) => {
    if (!map2.current) return
    let position = map2.current.getCenter();
    CenterLocaleRef.current = { lat: position.lat, lng: position.lng }
    getStationList(map2.current, CenterLocaleRef.current)
  }



  const getStationList = throttle(async (map, location) => {
    await queryCitysServiceInstance.current.cancel(cancelList.current);
    let zoom = map.getZoom();
    //判断大于11时，显示子项
    if (zoom < 9) {
      if (!wholeCityNums.current?.length) {
        debounceGetWholeCountryNums.current(map)
      } else {
        drawWholeCountryPoly(wholeCityNums.current, map)
      }
    } else {
      let citycode = (await location2CityCode({ map, lat: location.lat, lng: location.lng })).cityCode
      queryLabelingThrottler.current({ map, lat: location.lat, lng: location.lng, citycode })
    }
  }, 1000)

  const debounceGetWholeCountryNums = React.useRef(
    throttle(async (map) => {
      try {
        await queryMapAggregateLabelingServiceInstance.current.axiosFun({
          source: 2,
          filterCriteriaCodeList: ["freeCharging"]
        }, cancelList.current).then(res => {
          wholeCityNums.current = res?.data?.cityStationLabelingList
          if (map.getZoom() < 11) {
            drawWholeCountryPoly([...res?.data?.cityStationLabelingList], map)
          }
          setFreshLoading(false);
        })
        // @ts-ignore
      } catch (error: any) {
        setFreshLoading(false);
        if (error?.message === 'cancel') {
          return
        }
      }
    }, 500)
  );


  const drawWholeCountryPoly = (polys, _map: any) => {
    if (polys) {
      cleanMap(_map, Array.from(CountryMarkerCollector.values()));
      CountryMarkerCollector.clear();

      const handlePolys = polys.map(item => {
        return Array.from({ length: item.stationNum }, () => ({ ...item, lat: item.latitude, lng: item.longitude }))
      })
      let markerList = flatten(handlePolys)

      const markers = markerList.map((station, index) => {
        const markerNormalTmp = `<div class="marker zIndex1"></div>`;
        const marker = new AMap.Marker({
          content: markerNormalTmp,
          extData: {
            normal: markerNormalTmp,
            active: null,
            originData: { ...station },
            isActive: true,
          },
          position: [station.longitude, station.latitude],
          offset: new AMap.Pixel(0, 40)
        });
        CountryMarkerCollector.set(station.code + '' + index, marker);

        marker.on('click', e => {
          e.target.setTop(true);
          const extData = e.target.getExtData();
          e.target.setExtData({ ...extData, isActive: !extData.isActive })
          e.target.setzIndex(105);
          markerClick(_map, station);
        });
        return marker;
      });
      CountryClusterRef.current = new AMap.MarkerClusterer(_map, markers, {
        // 所有点的中心点
        averageCenter: true,
        gridSize: 110,
        zoomOnClick: false,
        // 自定义聚合显示
        renderClusterMarker: context => {
          let hasXp = false;
          context.markers.forEach(marker => {
            const station = marker.getExtData().originData;
            if (station.selfOperateStationNum > 0) {
              hasXp = true;
            }
          });
          let overThousand = context.count >= 1000
          context.marker.setContent(
            `<div class="map-marker-clusterer ${hasXp ? 'wrap-self' : 'wrap-partner'}">
              <span class="${overThousand ? 'small-size' : ''}">
                ${overThousand ? '999+' : context.count}
              </span>
            </div>`
          );
          context.marker.on('click', ev => {
            let zoom = _map.getZoom();
            //跳转到该区域位置
            _map.setZoomAndCenter(zoom + 1, ev.target.getPosition());
          });
        }
      });
    }

  }


  const markerClick = async (_map, station) => {
    // cancel所有请求 避免出现气泡后重新渲染导致气泡消失
    await queryCitysServiceInstance.current.cancel(cancelList.current);
    // 停止移动监听
    _map.off('moveend', mapMoveFunc);
    setTimeout(() => {
      _map.on('moveend', mapMoveFunc);
    }, 1500)
    let CurrentStationId = CurrentStationIdRef.current;
    _map.setCenter([station.longitude, station.latitude]);
    if (CurrentStationId === station.stationId) {
      return;
    }
    const currentMarker = MarkerCollector.get(CurrentStationId);
    const nextMarker = MarkerCollector.get(station.stationId);
    // 取消聚焦
    if (CurrentStationId) {
      currentMarker.setContent(currentMarker.getExtData().normal);
    }
    const extDataOfNewMarker = nextMarker.getExtData();
    // 聚焦：放大
    nextMarker.setContent(extDataOfNewMarker.active);

    getStationInfo((CurrentStationIdRef.current = station.stationId), station);

  };
  const cleanMap = (_map: any, markers) => {
    if (markers?.length) {
      _map.remove(markers);
    }
    if (ClusterRef.current) {
      ClusterRef.current.clearMarkers();
    }
    if (CountryClusterRef.current) {
      CountryClusterRef.current.clearMarkers();
    }
    _map.clearMap();
    // 清理完地图后，要把定位重新画上去
    const myLocation = MyLocaleRef.current;

    if (myLocation) {
      const marker = new AMap.Marker({
        content: MyLocationPoint,
        position: [myLocation.lng, myLocation.lat]
      });
      _map.add(marker);
    }
  };
  const drawStation = (_stationList: StationPoint[], _map: any) => {
    if (_stationList) {
      CurrentStationIdRef.current = '';
      setCurrentStation(null);
      cleanMap(_map, Array.from(MarkerCollector.values()));
      MarkerCollector.clear();

      const markers = _stationList.map(station => {
        let cls;
        let clsArr: string[] = [];
        if (station.operationMode === 1) {
          if (station.s4Num > 0) {
            clsArr = ['xpSuperFast'];
          } else if (station.dcNum > 0) {
            clsArr = ['xpQuick'];
          } else {
            clsArr = ['xpSlow'];
          }
        } else if (station.operationMode === 3) {
          if (station.showPreferredPartnership) {
            clsArr = ['preferred_third'];
          } else {
            clsArr = ['third'];
          }
        } else {
          if (station.showPreferredPartnership) {
            clsArr = ['preferred_third'];
          } else {
            clsArr = ['third'];
          }
        }
        if (station.showFreeV2) {
          clsArr.push('free');
        }
        if (station.showXpOwner) {
          clsArr.push('vip');
        }
        cls = clsArr.join(' ');

        const markerNormalTmp = `<div class="marker ${cls}"></div>`;
        const markerActiveTmp = `<div class="marker active ${cls}"></div>`;
        const marker = new AMap.Marker({
          // icon: Test,
          content: markerNormalTmp,
          extData: {
            normal: markerNormalTmp,
            active: markerActiveTmp,
            originData: { ...station }
          },
          position: [station.longitude, station.latitude]
        });
        MarkerCollector.set(station.stationId, marker);
        marker.on('click', () => {
          markerClick(_map, station);
        });
        return marker;
      });
      ClusterRef.current = new AMap.MarkerClusterer(_map, markers, {
        // 所有点的中心点
        averageCenter: true,
        gridSize: 110,
        zoomOnClick: false,
        // 自定义聚合显示
        renderClusterMarker: context => {
          let hasXp = false;
          context.markers.forEach(marker => {
            const station = marker.getExtData().originData;
            if (station.operationMode === 1) {
              hasXp = true;
            }
          });
          let overThousand = context.count >= 1000
          context.marker.setContent(
            `<div class="map-marker-clusterer ${hasXp ? 'wrap-self' : 'wrap-partner'
            }"><span class="${overThousand ? 'small-size' : ''}">
              ${overThousand ? '999+' : context.count}
            </span></div>`
          );

          context.marker.on('click', ev => {
            var zoom = _map.getZoom();
            //跳转到该区域位置
            _map.setZoomAndCenter(zoom + 1, ev.target.getPosition());
          });
        }
      });
    }
  };
  // 查询站点
  const queryStations = _map => {
    if (MyLocaleRef.current) {
      const optPro = new Promise<any>(resolve => {
        getLocationGeoPro($map)
          .then((res: any) => {
            console.log("res", res);

            resolve({ ...res });
          })
          .catch(() => {
            Toast.show('获取当前定位失败，请稍后重试', {
              containerStyle: { zIndex: 9999 }
            });
            resolve(defalutPoint);
          });
      });
      optPro
        .then(({ lng, lat, citycode }) => {
          console.log('lng, lat, citycode', lng, lat, citycode);
          // 获取具体的免费站信息
          queryLabelingThrottler.current(
            {
              map: $map,
              lng: lng,
              lat: lat,
              citycode
            }
          );
        })
    }
  };
  const returnMyLocation = useCallback(() => {
    const myLocation = MyLocaleRef.current;
    if (myLocation) {
      $map.setCenter([myLocation.lng, myLocation.lat]);
    }
  }, [$map]);
  const freshStationList = useCallback(() => {
    // 防止无地图调用以及重复点击
    if (!$map || freshLoading) return;
    // 刷新后清空站点缓存
    StationCache.clear();
    queryStations($map);
  }, [$map, freshLoading]);
  // 统一处理
  const position2Query = (_map, lng, lat, citycode) => {
    if (lng && lat) {
      _map.setCenter([lng, lat]);
      // 设置一下缩放
      _map.setZoom(13);
      const marker = new AMap.Marker({
        content: MyLocationPoint,
        position: [lng, lat]
      });
      _map.add(marker);
      MyLocaleRef.current = { lng, lat };
      CenterLocaleRef.current = { lng, lat };
    }
    queryStations(_map);
  };


  useEffect(() => {
    if (!$map) return;
    // $map.panBy(0, 0);
    initMarkers($map)
  }, [$map]);

  const initMarkers = async (map) => {
    // 优先获取url参数定位
    const urlLng = getUrlValue('lng');
    const urlLat = getUrlValue('lat');
    const rulesFlag = getUrlValue('rulesFlag');
    if (rulesFlag) {
      setRulesFlag(rulesFlag === 'false' ? false : true);
    }
    if (urlLng && urlLat) {
      let citycode = (await location2CityCode({ map: map, lat: urlLat, lng: urlLng })).cityCode
      position2Query(map, urlLng, urlLat, citycode);
    } else {
      const optPro = new Promise<any>(resolve => {
        getLocationGeoPro(map)
          .then((res: any) => {
            console.log('高德接口', res);
            const { lng, lat, citycode } = res;
            resolve({ lng, lat, citycode });
          })
          .catch(err => {
            console.log('高德获取定位失败', err);
            Toast.show('获取当前定位失败，请稍后重试', {
              containerStyle: {
                zIndex: 9999
              }
            });
            resolve(defalutPoint);
          });
      });
      optPro
        .then(({ lng, lat, citycode }) => {
          position2Query(map, lng, lat, citycode);
          return;
        })
        .catch(err => {
          console.error(err);
        });
    }
  }

  return (
    <div className="react-map-wrap">
      {/* 地图 */}
      <div id="amap-wrap">
        <div className="center-location">
        </div>
      </div>
      {/* 站点信息小卡片 */}
      {currentStation ? (
        <SwitchTransition>
          <CSSTransition
            key={currentStation.stationId}
            addEndListener={(node, done) =>
              node.addEventListener('transitionend', done, false)
            }
            classNames="fade"
          >
            <div className="card">
              <div className="card-title">
                <TypeTag station={currentStation} />
                <span className="station-name">
                  {currentStation.stationName}
                </span>
              </div>
              <div className="address">{currentStation.stationAddr}</div>
              {currentStation.openFlag === StationStatusEnum.OFF ? (
                <div className="card-detail">
                  <p className="advice">站点检修中，临时关闭，暂不建议前往</p>
                </div>
              ) : (
                <div className="card-detail">
                  <div className="pile-area">
                    {currentStation.s4Nums ? (
                      <div className="pile-item">
                        <span className='super-fast'>超快</span>
                        {currentStation.s4Nums}
                      </div>
                    ) : (
                      ''
                    )}
                    {(currentStation.dcNums && (currentStation.dcNums - currentStation.s4Nums)) ? (
                      <div className="pile-item">
                        <span className='fast'>快</span>
                        {currentStation.dcNums - currentStation.s4Nums}
                      </div>
                    ) : (
                      ''
                    )}
                    {currentStation.acNums ? (
                      <div className="pile-item">
                        <span className='slow'>慢</span>
                        {currentStation.acNums}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              )}
            </div>
          </CSSTransition>
        </SwitchTransition>
      ) : (
        ''
      )}
      {rulesFlag ? (
        <div className="top-adv">
          <a
            className="link"
            href="https://events.xiaopeng.com/78p8ah.html?ch=00035"
          >
            * "小鹏超充免费加电计划"政策细则<span className="arrow">{'>'}</span>
          </a>
        </div>
      ) : null}
      <div className={'fresh-box'}>
        <div
          className={freshLoading ? 'fresh-btn btn-span' : 'fresh-btn'}
          onClick={freshStationList}
        ></div>
      </div>
      <div className={'location-box'}>
        <div className="location-btn" onClick={returnMyLocation}></div>
      </div>
    </div>
  );
};

export default App;
